/**
 * Academic year for admission branding (Buddhist Era).
 * Change REACT_APP_ACADEMIC_YEAR in .env each year — rebuild/restart after change.
 */
export const ACADEMIC_YEAR =
  process.env.REACT_APP_ACADEMIC_YEAR || "2570";

/** เช่น "ปีการศึกษา 2570" */
export function academicYearLabel(prefix = "ปีการศึกษา") {
  return `${prefix} ${ACADEMIC_YEAR}`;
}

/** เช่น "ประจำปีการศึกษา 2570" */
export function academicYearFullLabel() {
  return academicYearLabel("ประจำปีการศึกษา");
}

/** เช่น "1/2570" สำหรับระบบชำระเงิน */
export function academicTerm(term = "1") {
  return `${term}/${ACADEMIC_YEAR}`;
}
